import { render } from "./shared-index.vue?vue&type=template&id=02b7f046&lang=pug"
import script from "./shared-index.vue?vue&type=script&lang=js"
export * from "./shared-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__